import { useEffect, useState } from 'react';

export const useGetGameTimer = (startDate: string | undefined) => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (!startDate) {
      return;
    }
    const interval = setInterval(() => {
      const newStartDate = new Date(startDate).getTime();
      const now = new Date().getTime();
      setTime(now - newStartDate);
    }, 1000);

    return () => clearInterval(interval);
  }, [startDate]);

  const seconds = Math.floor((time / 1000) % 60)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((time / (1000 * 60)) % 60)
    .toString()
    .padStart(2, '0');

  return `${minutes}:${seconds}`;
};
